import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Products from './components/pages/Products';
import CustomerSupport from './components/pages/CustomerSupport';
import ServiceCentre from './components/pages/ServiceCentre';
import Contact from './components/pages/Contact';
import FAQ from './components/pages/FAQ';
import ProductDetail from './components/pages/ProductDetail';
import AdminDashboard from './components/admin/AdminDashboard';
import LoginPage from './components/admin/LoginPage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

function AppContent() {
  const isAdminLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';

  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/support" element={<CustomerSupport />} />
          <Route path="/service-centre" element={<ServiceCentre />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/dashboard" element={isAdminLoggedIn ? <AdminDashboard /> : <LoginPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;